<div class="dialog-content-wrapper classroom-schedules-modal" id="appendblock">
  <mat-toolbar matDialogTitle class="theme-color m-0">
    <mat-toolbar-row>
      <button (click)="closeWithoutBuying()" mat-icon-button aria-label="Close dialog">
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
      <!-- <div class="dialog-title">{{ translationScope + '.titles.select_start_date' | transloco }}</div> -->
      <div class="dialog-title">{{ translationScope + '.titles.select_date_time' | transloco}}</div>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="pb-0 m-0" fusePerfectScrollbar>
    <!-- Slider main container -->
    <div class="schedule-swiper">
      <!-- Additional required wrapper -->
      <div class="schedule-swiper-wrapper">
        <div class="swiper-section-title">{{ translationScope + '.titles.select_start_date' | transloco }}</div>
        <!-- Slides -->
        <div *ngFor="let group of scheduleDateGroups; let i = index">
          <div class="swiper-slide row" *ngIf="i + 1 === dateSlideIndex">
            <div class="col-4 px-2" *ngFor="let schedule of group; let s = index">
              <div
                class="schedule-date"
                [ngClass]="{ active: schedule.id === selectedScheduleId }"
                (click)="selectedScheduleDate(schedule)"
              >
                {{ schedule.startDate | date: 'dd.MM.yyyy' }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="swiper-pagination position-static text-right px-3 " *ngIf="scheduleDateGroups.length > 1">
        <button (click)="previousDateGroup()">
          <i class="fas fa-chevron-left"></i>
        </button>
        {{ dateSlideIndex }} /{{ scheduleDateGroups.length }}
        <button (click)="nextDateGroup()"><i class="fas fa-chevron-right"></i></button>
      </div>
    </div>

    <div class="schedule-swiper mt-3" *ngIf="selectedScheduleId">
      <div class="schedule-swiper-wrapper timeslot-wrapper">
        <div class="swiper-section-title">{{ translationScope + '.titles.selected_timeslot' | transloco }}</div>
        <div *ngFor="let group of scheduleTimeGroups; let i = index">
          <div class="swiper-slide row" *ngIf="i + 1 === timeSlideIndex">
            <div class="col-4 col-md-2 px-2" *ngFor="let schedule of group; let s = index">
              <div
                class="schedule-date"
                [ngClass]="{ active: schedule.id === selectedScheduleTimeId }"
                (click)="selectedScheduleTime(schedule)"
              >
                {{ schedule.startDate | date: 'HH:mm' }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-2">
        {{ translationScope+'.time_zone_info' | transloco }}
      </div>

      <div class="swiper-pagination position-static text-right px-3" *ngIf="scheduleTimeGroups.length > 1">
        <button (click)="previousTimeGroup()">
          <i class="fas fa-chevron-left"></i>
        </button>
        {{ timeSlideIndex }} /{{ scheduleTimeGroups.length }}
        <button (click)="nextTimeGroup()"><i class="fas fa-chevron-right"></i></button>
      </div>
    </div>

    <!-- Show message  -->
    <div class="info-wrapper" >
      <ng-container *ngIf="selectedSchedule">
        <ng-container *ngIf="!selectedSchedule.isSignUpDateExpired; else signupDateExpire">
          <h6
          class="info-title"
          *ngIf="seats >= 4; else fewTimeSlots">
          {{seats}} {{translationScope+'.more_free_seats' | transloco}}
        </h6>
        </ng-container>
      </ng-container>

      <ng-template #fewTimeSlots>
        <h6
          class="info-title"
          *ngIf="seats < 4 && seats >= 2; else oneTimeSlot">
          {{seats}} {{translationScope+'.free_seats' | transloco}}
        </h6>
      </ng-template>
      <ng-template #oneTimeSlot>
        <h6
          class="info-title"
          *ngIf="seats == 1; else noTimeSlot">
          {{seats}} {{translationScope+'.free_seat' | transloco}}
        </h6>
      </ng-template>
      <ng-template #noTimeSlot>
        <h6 class="info-title sold-out">{{translationScope+'.sold_out' | transloco}}</h6>
      </ng-template>

      <ng-template #signupDateExpire>
        <h6 class="info-title">{{translationScope+'.signup_deadline_passed' | transloco}}</h6>
      </ng-template>
    </div>

    <div class="multi-booking-wrapper" *ngIf="seats > 0">
      <div class="form-group">
        <div class="custom-control custom-checkbox">
          <input
            [formControl]="multipleParticipant"
            type="checkbox"
            class="custom-control-input"
            id="multi-booking"
            name="multi-booking"
          />
          <label class="custom-control-label" for="multi-booking">
            {{ translationScope + '.check_multi_participant' | transloco }}
          </label>
        </div>

        <div class="mt-3" *ngIf="multipleParticipant.value">
          <div class="custom-input-group-label">
            {{ translationScope + '.select_participant' | transloco }}
          </div>

          <div class="custom-input-group">
            <div class="input-group">
              <div class="input-group-prepend">
                <button (click)="decreaseParticipant()" class="btn btn-outline-primary" type="button">-</button>
              </div>
              <input
                type="number"
                class="form-control text-center"
                [formControl]="numberOfParticipant"
                placeholder="0"
                aria-label="participants"
                aria-describedby="number-of-participants"
              />
              <div class="input-group-append">
                <button (click)="increaseParticipant()" class="btn btn-outline-primary" type="button">+</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div mat-dialog-actions>
    <div class="modal-footer">
      <!-- <button
      type="button"
      (click)="selectSchedule()"
      class="btn btn-primary">
     Select Schedule
    </button> -->

    <ng-container *ngIf="userInfo$ | async as user; else annonymous">
      <button
        [disabled]="
        instructor?.userId === user.sub || seats <=0 || selectedSchedule == null || selectedSchedule.isSignUpDateExpired
        "
        (click)="requestBooking(user)"
        class="btn btn-primary">
        <b class="text-uppercase">{{translationScope+'.action_buttons.buy' | transloco}}</b>
      </button>
    </ng-container>

    <ng-template #annonymous>
      <button
        (click)="loginOrRegister()"
        class="btn btn-primary">
        <b class="text-uppercase">{{translationScope+'.action_buttons.login_required' | transloco}}</b>
      </button>
    </ng-template>
    </div>
  </div>
</div>
